import { ENROL_LOYALTY_ACCOUNT, USER_LOGOUT, USER_LOGIN, USER_REGISTRATION } from 'actions/apiActionConstants'
import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import { canBroadcast, LUX_BROADCAST_CHANNEL } from 'lib/web/broadcastChannelUtils'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import type { AppDispatch, AppStore } from './store'

function initialiseBroadcastListener(store: AppStore) {
  if (canBroadcast()) {
    const channel = new BroadcastChannel(LUX_BROADCAST_CHANNEL)
    channel.onmessage = e => {
      if (e.data.action) {
        switch (e.data.action.api) {
          case USER_LOGOUT:
            if (store.getState().auth.account.memberId) {
              store.dispatch({
                ...e.data.action,
                supressBroadcast: true,
              })
            }
            break
          case USER_LOGIN:
          case USER_REGISTRATION:
            if (!store.getState().auth.account.memberId) {
              store.dispatch({
                ...e.data.action,
                supressBroadcast: true,
              })
            }
            break
          case ENROL_LOYALTY_ACCOUNT: {
            // Another tab enrolled this customer. Read the account so this tab stops offering to
            // enrol them, as a second enrolment fails now the account exists.
            const state = store.getState()
            const memberId = state.auth.account.memberId
            if (memberId && memberId === e.data.memberId && !getHasLoyaltyAccount(state)) {
              const dispatch: AppDispatch = store.dispatch
              dispatch(fetchLoyaltyAccount(undefined, { force: true }))
            }
            break
          }
        }
      }
    }
  }
}

export default initialiseBroadcastListener
